import { render, staticRenderFns } from "./PromotionFactorQuery.vue?vue&type=template&id=10c07ede&"
import script from "./PromotionFactorQuery.vue?vue&type=script&lang=js&"
export * from "./PromotionFactorQuery.vue?vue&type=script&lang=js&"
import style0 from "./PromotionFactorQuery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionFactorQuery.vue"
export default component.exports